import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../pages/auth/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import Profile from "../pages/profile/Profile";
import Trackdevice from "../pages/dashboard/Trackdevice";
import GPSDetails from "../pages/gps/GPSDetails";
import GPSMap from "../pages/gps/GPSMap";
import MainLayout from "../layouts/MainLayout";
import CreateShipment from "../pages/shipment/CreateShipment";
import Navigation from "../pages/gps/Navigator";




const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute> <MainLayout /></ProtectedRoute>}>
                <Route path="dashboard-old" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="profile" element={<Profile />} />
                <Route path="gps" element={<GPSDetails />} />
                <Route path="gps/:shipmentId" element={<GPSDetails />} />
                <Route path="/gps-map" element={<ProtectedRoute><GPSMap /></ProtectedRoute>} />
                <Route path="/create-shipment" element={<ProtectedRoute><CreateShipment /></ProtectedRoute>} />
                <Route path="/navigator-panel" element={<ProtectedRoute><Navigation /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute><Trackdevice /></ProtectedRoute>} />
            </Route>

            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
    );
};

export default AppRoutes;
